import { SITE_CONFIG } from "@/config/site";

/**
 * Build a full backend API URL from a relative path.
 * Mirrors getImageUrl: pass an absolute URL and it is returned untouched.
 *
 *   getApiUrl("/form-requests") -> "https://.../api/form-requests"
 */
export const getApiUrl = (path = "") => {
  if (path.startsWith("http")) return path;
  return `${SITE_CONFIG.API_BASE_URL}${path}`;
};
